import React, { useCallback, useContext, useEffect, useState } from "react";
import { Button, Input, Modal, Table, Tooltip } from "antd";
import axios from "axios";
import { NotificationInfo, UserInfo } from "../../../context";
import MerchantLayout from "../../layout/MerchantLayout";
import { AuditOutlined, DeleteOutlined } from "@ant-design/icons";
import MerchantOrdersDetails from "./MerchantOrdersDetails";

const MerchantOrders = () => {
  const [search, setSearch] = useState("");
  const [merchantOrderSaveList, setMerchantOrderSaveList] = useState({
    data: [],
    ready: false,
  });
  const [productList, setProductList] = useState({
    data: [],
    ready: false,
  });
  const tableLayout = "";
  const scroll = {};
  const { userData } = useContext(UserInfo);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [selectedData, setSelectedData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [deleteDialog, setDeleteDialog] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const { rerunNotif } = useContext(NotificationInfo);

  const tableProps = {
    bordered: false,
    loading,
    size: "medium",
    // expandable,
    showHeader: true,
    scroll,
    tableLayout,
  };

  const columns = [
    {
      title: "Transaction Number",
      dataIndex: "transaction_id",
      render: (text, record) => (
        <p
          style={{
            textTransform: "uppercase",
            fontWeight: "bold",
          }}
        >
          {text}
        </p>
      ),
    },
    {
      title: "Customer Name",
      dataIndex: "customer_name",
      render: (text, record) => <p>{text}</p>,
    },
    {
      title: "Table Number",
      dataIndex: "table_no",
      render: (text, record) => <p>{text}</p>,
    },
    {
      title: "Status",
      dataIndex: "service_category",
      render: (text, record) => (
        <p
          style={{
            textTransform: "uppercase",
            color: text === "dine" ? "green" : "blue",
            fontWeight: "bold",
          }}
        >
          {text === "dine" ? "DINE" : "TAKE OUT"}
        </p>
      ),
    },
    {
      title: "",
      dataIndex: "",
      align: "center",
      render: (text) => (
        <p style={{ width: window.innerWidth > 575 ? "auto" : 90 }}>
          <Tooltip title="Order Details">
            <Button
              type="dashed"
              shape="circle"
              onClick={() => {
                setSelectedData(text);
                setOpenDrawer(true);
              }}
              icon={<AuditOutlined />}
              style={{ marginRight: 10 }}
            />
          </Tooltip>
          <Tooltip title="Delete Order">
            <Button
              type="dashed"
              shape="circle"
              onClick={() => {
                setSelectedData(text);
                setDeleteDialog(true);
              }}
              icon={<DeleteOutlined />}
            />
          </Tooltip>
        </p>
      ),
    },
  ];

  const tableColumns = columns.map((item) => ({
    ...item,
    ellipsis: false,
  }));

  const getMerchantOrderSaveList = useCallback(() => {
    var params = { user_id: userData.data.id, status: 0, orderby: "asc" };
    axios
      .get("user/merchant/customer-order-list", {
        params,
      })
      .then((response) => {
        const data = response.data;
        setMerchantOrderSaveList({ data, ready: true });
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  }, [userData.data.id]);

  const getProductList = useCallback(() => {
    var params = { user_id: userData.data.id };
    axios
      .get("user/merchant/product-list", { params })
      .then((response) => {
        const data = response.data;
        setProductList({ data, ready: true });
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  }, [userData.data.id]);

  useEffect(() => {
    getMerchantOrderSaveList();
    getProductList();
  }, [getMerchantOrderSaveList, getProductList]);

  const searchable = merchantOrderSaveList.data.filter((data) => {
    return (
      data.customer_name.toLowerCase().indexOf(search.toLowerCase()) >= 0 ||
      data.transaction_id.toLowerCase().indexOf(search.toLowerCase()) >= 0
    );
  });

  const handleOk = () => {
    setConfirmLoading(true);
    setTimeout(() => {
      setDeleteDialog(false);
      setConfirmLoading(false);
      handleDeleteCustomerOrder();
    }, 2000);
  };

  const handleDeleteCustomerOrder = () => {
    const formdata = new FormData();
    formdata.append("user_id", userData.data.id);
    formdata.append(
      "transaction_id",
      selectedData !== null ? selectedData.transaction_id : ""
    );
    // setLoadings(true);
    axios
      .post("user/merchant/delete-customer-order", formdata)
      .then((response) => {
        const data = response.data;
        if (data === "success") {
          rerunNotif("success", "Delete order successfully.");
          setTimeout(() => {
            // setLoadings(false);
            getMerchantOrderSaveList();
          }, 1000);
        }
      })
      .catch((error) => {
        console.log("Error: ", error);
        // setLoadings(false);
      });
  };

  return (
    <MerchantLayout>
      <div style={{ overflowX: "auto" }}>
        <div style={{ marginBottom: 10 }}>
          <Input
            placeholder="Search track id or name"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            style={{
              border: "2px solid #e5e5e5",
              width: window.innerWidth < 576 ? "100%" : 300,
            }}
            size="large"
          />
        </div>

        <Table
          {...tableProps}
          pagination={{
            position: ["bottomCenter"],
          }}
          columns={tableColumns}
          dataSource={searchable.length > 0 ? searchable : []}
          scroll={scroll}
          rowKey={(record) => record.transaction_id}
        />
      </div>

      {openDrawer && (
        <MerchantOrdersDetails
          open={openDrawer}
          close={() => setOpenDrawer(false)}
          setLoading={setLoading}
          getMerchantOrderSaveList={() => getMerchantOrderSaveList()}
          selectedData={selectedData}
          productList={productList}
        />
      )}

      <Modal
        title="Are you sure to delete this product?"
        open={deleteDialog}
        onOk={handleOk}
        confirmLoading={confirmLoading}
        onCancel={() => setDeleteDialog(false)}
      />
    </MerchantLayout>
  );
};

export default MerchantOrders;
